import { ApplicationApi } from 'api/ApplicationApi';
import { SettingsCategory } from 'api/v1/data-contracts';

export const userSettingsKeys = {
	all: ['settings'] as const,
	settings: (category: SettingsCategory) =>
		[...userSettingsKeys.all, category] as const,
};

export const userVisibilitySettingsQuery = (
	api: ApplicationApi,
	category: SettingsCategory
) => ({
	queryKey: userSettingsKeys.settings(category),
	queryFn: async () => await api.getUserVisibilitySettings({ category }),
});

export const userTabsSettingsQuery = (
	api: ApplicationApi,
	category: SettingsCategory
) => ({
	queryKey: userSettingsKeys.settings(category),
	queryFn: async () => await api.getUserTabsSettings({ category }),
});
